<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
        <path
            d="M198.17,97.32c0,52.9-43.22,95.79-96.53,95.79A96.64,96.64,0,0,1,55,181.19l-53.45,17,17.42-51.39A94.79,94.79,0,0,1,5.1,97.32c0-52.91,43.22-95.8,96.54-95.8s96.53,42.89,96.53,95.8ZM101.64,16.78c-44.77,0-81.17,36.12-81.17,80.54a79.7,79.7,0,0,0,15.46,47.22L25.8,174.44,57,164.54a81.16,81.16,0,0,0,44.66,13.31c44.75,0,81.16-36.13,81.16-80.53s-36.41-80.54-81.16-80.54Zm48.75,102.6c-.6-1-2.18-1.57-4.53-2.74s-14-6.86-16.17-7.64-3.76-1.17-5.32,1.17-6.12,7.64-7.5,9.21-2.75,1.76-5.12.59-10-3.66-19-11.65A71.41,71.41,0,0,1,79.53,92.06c-1.37-2.35-.14-3.62,1-4.79s2.37-2.74,3.55-4.11a16.09,16.09,0,0,0,2.37-3.93,4.26,4.26,0,0,0-.2-4.11C85.7,74,81,62.4,79,57.7s-3.94-3.91-5.32-3.91-3-.19-4.53-.19a8.71,8.71,0,0,0-6.31,2.94c-2.17,2.35-8.28,8-8.28,19.58S63,98.82,64.2,100.38s16.37,26.05,40.43,35.45,24.06,6.26,28.4,5.87,14-5.68,16-11.16,2-10.19,1.39-11.16Zm0,0"
            class="wp-background"
            :fill="color"
            :class="{ 'special-background': specialBackgroundMode }"
        ></path>
    </svg>
</template>

<script>
export default {
    name: "WhatsappIcon",
    props: {
        specialBackgroundMode: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            default: "#ffffff",
        },
    },
};
</script>

<style scoped>
.wp-background {
    fill-rule: evenodd;
}
</style>
